import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { styles } from './styles';
import { Link } from 'gatsby-theme-material-ui';
import Section from '../../../shared/Section/Section';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';

const ProfessionCard = ({ title, salary, description, img }) => {
  return (
    <Paper elevation={0} sx={styles.cardRoot}>
      <Box sx={styles.iconBox}>
        <GatsbyImage
          image={getImage(img)}
          alt=""
          loading="lazy"
          imgStyle={{ objectFit: 'cover', height: '100%', width: '100%' }}
        />
      </Box>
      <Typography variant="desktopH4" color={'kit.text.h'} mt={2}>
        {title}
      </Typography>
      <Typography
        variant="desktopP3"
        color={'kit.text.secondary'}
        sx={{ mt: { xs: 1.5, lg: 2 } }}
      >
        {salary}
      </Typography>
      <Typography
        variant="desktopP3"
        color={'kit.text.main'}
        sx={{ mt: { xs: 1.5, lg: 2 } }}
      >
        {description}
      </Typography>
    </Paper>
  );
};

function AboutDSprofession({
  title,
  professionList,
  imgIcon,
  image,
  link,
  ymEvent,
}) {
  const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [isMediaQueryReady, setIsMediaQueryReady] = useState(false);
  useEffect(() => {
    if (!isMediaQueryReady) {
      setIsMediaQueryReady(true);
    }
  }, [isBelowMd]);
  if (!isMediaQueryReady) {
    return null;
  }

  return (
    <Section
      theme={isBelowMd ? 'light' : 'default'}
      withoutBg
      customStyles={styles.section}
    >
      <Grid container sx={styles.container}>
        <Grid item xs={12} lg={8.75}>
          <Typography variant="desktopH3" color={'kit.text.main'}>
            {title}
          </Typography>
          <Grid container columnSpacing={2} sx={styles.cardsContainer}>
            {professionList.map((item) => (
              <Grid key={item.title} item xs={12} lg={4}>
                <ProfessionCard {...item} img={imgIcon} />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={0} lg={3.25} sx={styles.imgGrid}>
          <GatsbyImage
            image={getImage(image)}
            alt=""
            loading="lazy"
            imgStyle={{ objectFit: 'cover', height: '100%', width: '100%' }}
          />
        </Grid>
        <Box>
          <Typography
            variant="desktopP3"
            color={'kit.text.secondary'}
            sx={{ mt: { xs: 1.5, lg: 2 } }}
          >
            *средняя зарплата по данным Хабр Карьеры
          </Typography>
          <Box sx={{ mt: { xs: 4, lg: 6 } }}>
            <Link
              underline="none"
              href={link}
              variant="kitPrimary"
              sx={{ fontSize: { xs: 14, lg: 16 } }}
              onClick={() => {
                sendYandexMetrikaEvent(ymEvent);
              }}
            >
              Подробнее о профессиях Data Science
            </Link>
          </Box>
        </Box>
      </Grid>
    </Section>
  );
}

export default AboutDSprofession;
